
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staff/notification/create-notification",
      function () {
        return require("private-next-pages/staff/notification/create-notification.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staff/notification/create-notification"])
      });
    }
  